import React, { Children, ReactNode } from 'react'; // eslint-disable-line

import t from '../../theme/newstyles';

/** @jsxImportSource @emotion/react */

export const HeaderNav = (props: { children?: ReactNode }) => {
  return <div css={[t.flex_auto, t.flex, t.flex_row, t.justify_end]}>{props.children}</div>;
};
